var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"category-faq",class:{ active: _vm.item.value === _vm.selectedCategoryValue },on:{"click":function($event){return _vm.setSelectedCategoryValue(_vm.item.value)}}},[_vm._v(" "+_vm._s(_vm.item.name)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }